














import {computed, defineComponent, ref } from "@vue/composition-api"
import { gsap, Power2, TweenMax } from "gsap"


export default defineComponent({
  name: "Card",
  props: {
    back: {
      type: String,
      required: true,
    },
    flipDuration: {
      type: Number,
      required: false,
      default: 1,
    },
    identifier: {
      required: false,
      default: undefined,
    }
  },
  setup(props, {emit}) {
    const inner = ref<HTMLBodyElement>()
    const isImage= computed(() => props.back.endsWith('.jpg') || props.back.endsWith('png'))

    function flip() {
      TweenMax.to(
        inner.value!,
        props.flipDuration,
        {
          css:{rotationY:"+=180"},
          ease: Power2.easeInOut,
        },
      )
      TweenMax.to(inner.value!, props.flipDuration/2, {css:{z:"-=100"}, yoyo: true, repeat:1, ease: Power2.easeIn})
    }

    function pairedAnimation() {
      gsap.to(inner.value!, props.flipDuration/2, {css: {z: "-=100"}, yoyo: true, repeat: 1, ease: Power2.easeIn})
    }

    function addFlipToTimeline(timeline: gsap.core.Timeline, position?: number) {
      if (position !== undefined) {
        timeline.to(inner.value!, props.flipDuration, {css:{rotationY:"+=180"}, ease: Power2.easeInOut}, position)
      } else {
        timeline.to(inner.value!, props.flipDuration, {css:{rotationY:"+=180"}, ease: Power2.easeInOut})
      }
    }

    function addPairedAnimationToTimeline(timeline: gsap.core.Timeline, position?: number) {
      if (position !== undefined) {
        timeline.to(inner.value!, props.flipDuration/2, {css: {z: "-=100"}, yoyo: true, repeat: 1, ease: Power2.easeIn}, position)
      } else {
        timeline.to(inner.value!, props.flipDuration/2, {css: {z: "-=100"}, yoyo: true, repeat: 1, ease: Power2.easeIn})
      }
    }

    function onClick() {
      if(gsap.isTweening(inner.value!)) {
        console.log('Animating, skip click')
        return
      }
      emit(
        'flashcard-click',
        { back: props.back, identifier: props.identifier })
    }

    return {isImage, onClick, inner, flip, pairedAnimation, addFlipToTimeline, addPairedAnimationToTimeline }
  }
})
